import { createTheme } from '@mui/material/styles';

// Extend the Theme interface to include custom properties
declare module '@mui/material/styles' {
  interface Palette {
    border: {
      main: string;
      light: string;
    };
  }
  interface PaletteOptions {
    border?: {
      main?: string;
      light?: string;
    };
  }
}

const theme = createTheme({
  shape: {
    borderRadius: 6,
  },
  palette: {
    primary: {
      main: '#1A55F9',
    },
    border: {
      main: '#D4DADF',
      light: '#E0E0E0',
    },
  },
  typography: {
    fontFamily: 'Poppins, sans-serif',
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',

          // 👇 Hover border color for ALL Outlined select/input
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1A55F9 !important',
          },

          // 👇 Focus border color
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1A55F9 !important',
          },
        },

        notchedOutline: {
          borderColor: '#D4DADF',
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        contained: {
          borderRadius: '6px !important',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
});

export default theme;
